import React from 'react'
import { useIntl } from 'react-intl'
import { Status } from './s'
import Label from './label'

const IntegrationStatus = ({ status, className }) => (
    <Status className={className}>
        <Label status={status} />
    </Status>
)

const statusTexts = {
    not_configured: {
        id: 'integration_status_not_configured',
        defaultMessage: 'Not configured'
    },

    configured: {
        id: 'integration_status_configured',
        defaultMessage: 'Configured'
    },

    pending: {
        id: 'status_pending',
        defaultMessage: 'Pending'
    },

    connected: {
        id: 'integration_status_connected',
        defaultMessage: 'Connected'
    },

    active: {
        id: 'integration_status_connected_active',
        defaultMessage: 'Connected and active'
    },

    authorization_failure: {
        id: 'integration_status_authorization_failure_status',
        defaultMessage: 'Authorization failure'
    }
}

export const useIntegrationStatusTextFormatter = () => {
    const { formatMessage } = useIntl()

    return status => {
        const message = statusTexts[status] ?? null

        return message ?
            formatMessage(message) :
            null
    }
}

export default IntegrationStatus